export enum SyncRecordsEachTimeStrategy {
  onlyOnceAtCreation = 'onlyOnceAtCreation',
  eachTimeIsUpdated = 'eachTimeIsUpdated',
}
